import React from 'react';
import activities from '../../assests/img/activities.jpg';

const Activities = () => {

    return (
        <>
            <div className='inner_top_about_us'>
                <div id="bg" className="data-typography-1 data-theme-1">
                    <div className="page-wraper">
                        <div className="page-content bg-white">
                            <div className="dz-bnr-inr dz-bnr-inr-sm style-1 text-center overlay-primary-dark">
                                <div className="coustom_container">
                                    <div className="dz-bnr-inr-entry">
                                        <div className="pheading">
                                            <h1>Activities</h1>
                                        </div>
                                        <nav aria-label="breadcrumb" className="breadcrumb-row">
                                            <ul className="breadcrumb">
                                                <li className="breadcrumb-item">
                                                    <a href="/">Home</a>
                                                </li>
                                                <li className="mx-2">
                                                    /
                                                </li>
                                                <li className="breadcrumb-item active" aria-current="page">
                                                    Activities
                                                </li>
                                            </ul>
                                        </nav>
                                    </div>
                                </div>
                            </div>


                            <section className="content-inner section-wrapper5 pt-5 pb-5">
                                <div className="coustom_container">
                                    <div className="row">
                                        <div
                                            className="col-xl-9 col-lg-6 m-b30 wow fadeInUp"
                                            data-wow-delay="0.4s"
                                        >
                                            <div id="pagedata" className="pagedata">
                                                <p style={{ textAlign: "justify" }}>
                                                    <img src={activities} alt="activities" width="100%" />
                                                </p>
                                                <ul>
                                                    <li>History club</li>
                                                    <li>Science club</li>
                                                    <li>Astronomy club</li>
                                                    <li>Environment club</li>
                                                    <li>Philosophy club</li>
                                                    <li>Math club</li>
                                                    <li>Book club</li>
                                                    <li>Language club</li>
                                                    <li>Elocution, Debate and Public Speaking</li>
                                                    <li>KCMS Model UN</li>
                                                    <li>Computer and Programming</li>
                                                    <li>Clay modelling</li>
                                                    <li>Pottery workshop</li>
                                                    <li>Carpentry workshop</li>
                                                    <li>Life skill workshop</li>
                                                    <li>Vocational and Skill Education</li>
                                                    <li>Painting</li>
                                                    <li>Dance and Music</li>
                                                    <li>Drama and Nukkad Natak</li>
                                                    <li>Origami and Paper crafting  </li>
                                                    <li>Gardening</li>
                                                    <li>Composting and waste management</li>
                                                    <li>Yoga</li>
                                                    <li>Cycling and Skating</li>
                                                    <li>Chess</li>
                                                    <li>Volleyball</li>
                                                    <li>Basketball</li>
                                                    <li>Cricket</li>
                                                    <li>Kabaddi and Kho-Kho</li>
                                                    <li>Athletics</li>
                                                    <li>Social outreach programmes</li>
                                                </ul>
                                            </div>
                                        </div>

                                        <div
                                            className="col-xl-3 col-lg-6 wow fadeInUp"
                                            data-wow-delay="0.2s"
                                        >
                                            <div className="bg-lgrey">
                                                <div className="subMenubg active">
                                                    <a href="spiritual-care-and-wellbeing" target="_self" className="submenu">
                                                        Spiritual care and Wellbeing
                                                    </a>
                                                </div>
                                                <div className="subMenubg">
                                                    <a
                                                        href="academic-life"
                                                        target="_self"
                                                        className="submenu"
                                                    >
                                                        Academic Life
                                                    </a>
                                                </div>
                                                <div className="subMenubg">
                                                    <a href="sporting-life" target="_self" className="submenu">
                                                        Sporting Life
                                                    </a>
                                                </div>
                                                <div className="subMenubg">
                                                    <a href="co-curricular" className="submenu">
                                                        Co-curricular
                                                    </a>
                                                </div>
                                                <div className="subMenubg">
                                                    <a href="social-responsibility" target="_self" className="submenu">
                                                        Social Responsibility
                                                    </a>
                                                </div>
                                                <div className="subMenubg">
                                                    <a
                                                        href="activities"
                                                        target="_self"
                                                        className="submenu"
                                                    >
                                                        Activities
                                                    </a>
                                                </div>
                                                <div className="subMenubg">
                                                    <a
                                                        href="amenities"
                                                        target="_self"
                                                        className="submenu"
                                                    >
                                                        Amenities
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </section>
                        </div>

                        {/* <button className="scroltop icon-up" type="button">
                            <i className="fas fa-arrow-up"></i>
                        </button> */}
                    </div>
                </div>
            </div >
        </>
    )
}

export default Activities;